// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__32aGZ","label":"SetPasswdForm_label__1rP7H"};